import {
  Component,
  ElementRef,
  HostListener,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { AuthService } from '../../services/auth.service';
import { GuestService } from '../../services/guest.service';

import 'jquery';
import {
  LanguageService,
  LanguagesEnum,
} from '../../services/language.service';
// import * as $ from 'jquery';

// interface BootstrapJQuery extends JQuery {
//   collapse(action: string): JQuery;
// }

@Component({
  selector: 'app-top-nav',
  templateUrl: './top-nav.component.html',
  styleUrls: ['./top-nav.component.scss'],
})
export class TopNavComponent implements OnInit {
  LanguagesEnum = LanguagesEnum;
  //
  showLogout: Observable<boolean>;

  @ViewChild('collapsible') private collapsibleElement: ElementRef;
  @Input() title: string;

  constructor(
    private gs: GuestService,
    private auth: AuthService,
    public ls: LanguageService,
  ) {
    this.showLogout = this.auth.isLoggedIn$;
  }

  ngOnInit() {}

  private collapseMenu() {
    const el = this.collapsibleElement.nativeElement;
    if (el) {
      $(el)['collapse']('hide');
    }
  }

  @HostListener('click', ['$event.target'])
  onClick(target: HTMLElement) {
    if (target instanceof HTMLAnchorElement) {
      this.collapseMenu();
    }
  }

  onLogout() {
    this.auth.logout().catch(err => {});
  }
}



// WEBPACK FOOTER //
// ./src/app/components/top-nav/top-nav.component.ts